import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';

const EmployeesPage = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const columns = [
    'Employee ID',
    'Name',
    'Email',
    'Phone',
    'City',
    'State',
    'Role',
    'Created At',
  ];

  useEffect(() => {
    const fetchEmployees = async () => {
      const token = localStorage.getItem('employeeToken');
      if (!token) {
        window.location.href = "/employee-login";
        return;
      }

      try {
        const apiURL = `${apiBaseURL}/api/employees`;
        const response = await axios.get(apiURL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setEmployees(response.data);
      } catch (err) {
        setError('Failed to fetch employees.');
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [apiBaseURL]);

  const data = employees.map(ev => ({
    employee_id: ev.employee_id,
    name: ev.name || '—',
    email: ev.email || '—',
    phone: ev.phone || '—',
    city: ev.city || '—',
    state: ev.state || '—',
    role: ev.role || '—',
    created_at: ev.created_at ? new Date(ev.created_at).toLocaleString() : '—',
  }));

  const handleDownloadExcel = () => {
    const now = new Date();

    const formattedDateHeader = now.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const formattedFileTime = now.toISOString().replace(/T/, '_').replace(/:/g, '-').split('.')[0];
    const fileName = `Employees_Master_List_${formattedFileTime}.xlsx`;

    const header = [
      ['OrderMinds Freelancing Solutions LLP'],
      ['Employees Master List'],
      [`Downloaded on: ${formattedDateHeader}`],
      [],
    ];

    const tableHeaders = columns;
    const tableData = data.map(row =>
      columns.map(col => row[col.toLowerCase().replace(/ /g, '_')])
    );

    const worksheetData = [...header, tableHeaders, ...tableData];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');

    XLSX.writeFile(workbook, fileName);
  };

  const Table = ({ columns, data }) => (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto bg-white shadow rounded-lg">
        <thead>
          <tr className="bg-gray-200">
            {columns.map((col, idx) => (
              <th key={idx} className="px-3 py-2 text-left">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-3 text-center text-gray-500">No employees found.</td>
            </tr>
          ) : (
            data.map((row, rowIdx) => (
              <tr key={rowIdx} className="border-b">
                {columns.map((col, colIdx) => (
                  <td key={colIdx} className="px-3 py-2 whitespace-nowrap">
                    {row[col.toLowerCase().replace(/ /g, '_')]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  if (loading) return <div className="p-6">Loading employees data...</div>;
  if (error) return <div className="p-6 text-red-500">{error}</div>;

  return (
    <div className="flex-1 p-6 bg-gray-50 ml-64">
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-2xl font-semibold">Employees</h2>
        <button
          onClick={handleDownloadExcel}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
        >
          Download Excel
        </button>
      </div>
      <Table columns={columns} data={data} />
    </div>
  );
};

export default EmployeesPage;
